
import { Injectable } from "@angular/core";

import { CustomFormControl } from "digital-core";
import { BeneficiaryInfo } from "../models";

@Injectable({
    providedIn: 'root'
  })
  
export class PercentageValidator{
    constructor(){}

    sumMustBe100orLess(selectedIndex:CustomFormControl, beneficiariesList: BeneficiaryInfo[],component:CustomFormControl){
 
        let componentValue: string = component.value;
        if (!componentValue) {
            return null;
        }
        let sum = Number(component.value);
        let editIndex = Number(selectedIndex.value);
        
        beneficiariesList.forEach((value,index)=>{
            if(index!= editIndex){
                sum += Number(value.PercentageSplit)
            }
        });
        
        if(sum > 100){
            return{ percentageTotal: true}
        } 
     
        return null;

    }

    minPercentageValidator(component: CustomFormControl) {

        let currentValue = Number(component.value);

        if (currentValue < 1) {
            return { percentageMin: true }
        }

        return null;
    }
}